import { Controller } from "@hotwired/stimulus";
import CustomAmountControl from "../src/custom_amount_control";

// Connects to data-controller="amount-selector"
export default class extends Controller {
  static targets = ["preset", "customAmount"];

  connect() {
    this.customAmountControl = new CustomAmountControl(this.customAmountTarget);

    if (this.presetTargets.some((e) => e.checked)) {
      this.clearCustom();
    } else {
      this.validateCustom();
    }
  }

  clearCustom() {
    this.customAmountControl.value = "";
  }

  validateCustom() {
    if (this.customAmountControl.checked) {
      for (const preset of this.presetTargets) {
        preset.checked = false;
      }
    }
  }

  disambiguate() {
    this.customAmountControl.disabled = !this.customAmountControl.checked;
  }

  get active() {
    return !this.element.closest(":disabled");
  }

  get value() {
    if (this.customAmountControl.checked) {
      return this.customAmountControl.value;
    }

    for (const preset of this.presetTargets) {
      if (preset.checked) {
        return preset.value;
      }
    }

    return undefined;
  }

  set currencySymbol(symbol) {
    for (const preset of this.presetTargets) {
      const currencySymbolEl = document.querySelector(
        `label[for=${preset.id}] .currency-symbol`,
      );
      currencySymbolEl.innerText = symbol;
    }

    this.customAmountControl.prefix = symbol;
  }
}
